import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPin01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.324 1c-.362 0-.698 0-.973.025-.288.026-.647.088-.979.308a2 2 0 0 0-.853 1.26c-.081.39-.005.746.077 1.023.08.265.204.577.338.913l1.023 2.556c.014.035.035.073.042.11L7 7.307v2.13c0 .07.001.14-.002.21l-.002.003a6.053 6.053 0 0 1-.127.163L5.27 11.81c-.31.387-.583.729-.775 1.019-.187.283-.415.684-.415 1.169a2 2 0 0 0 .752 1.565c.379.302.834.375 1.172.406.347.031.785.031 1.28.031H11v6a1 1 0 1 0 2 0v-6h3.715c.495 0 .933 0 1.28-.031.338-.031.793-.104 1.172-.406a2 2 0 0 0 .752-1.565c0-.485-.228-.886-.415-1.169-.192-.29-.466-.632-.775-1.019l-1.598-1.996c-.043-.055-.088-.11-.13-.165v-.003A5.995 5.995 0 0 1 17 9.439V7.193l.043-.108 1.023-2.556c.134-.336.259-.648.338-.913.082-.277.158-.633.077-1.023a2 2 0 0 0-.853-1.26c-.332-.22-.69-.282-.979-.308C16.374 1 16.038 1 15.676 1H8.324Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgPin01.displayName = 'Pin01';
export default SvgPin01;
